export default __webpack_public_path__ + "static/media/shiweihao.1d2f1842.jpg";